import { defineStore } from 'pinia'

export interface IMessagingState {
  isOpen: boolean
  targetFamilyId: string | null
  targetMemberId: string | null
  targetTab: 'activity' | 'announcements' | null
  targetConversationId: string | null
  /** Handoff state for drawer → full page transition */
  expandTarget: {
    conversationId: string | null
    participantName: string | null
    leftPanel: 'inbox' | 'directory' | null
  }
}

export const useMessagingStore = defineStore('messaging', {
  state: (): IMessagingState => ({
    isOpen: false,
    targetFamilyId: null,
    targetMemberId: null,
    targetTab: null,
    targetConversationId: null,
    expandTarget: {
      conversationId: null,
      participantName: null,
      leftPanel: null,
    },
  }),
  actions: {
    openMessager() {
      this.isOpen = true
    },
    closeMessager() {
      this.isOpen = false
      this.targetFamilyId = null
      this.targetMemberId = null
      this.targetTab = null
      this.targetConversationId = null
    },
    toggleMessager() {
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        this.targetFamilyId = null
        this.targetMemberId = null
        this.targetTab = null
        this.targetConversationId = null
      }
    },
    openToConversation(conversationId: string) {
      this.targetConversationId = conversationId
      this.isOpen = true
    },
    openToMember(familyId: string, memberId: string) {
      this.targetFamilyId = familyId
      this.targetMemberId = memberId
      this.isOpen = true
    },
    openToAnnouncements() {
      this.targetTab = 'announcements'
      this.isOpen = true
    },
    clearTarget() {
      this.targetFamilyId = null
      this.targetMemberId = null
      this.targetTab = null
    },
    /** Set handoff state before navigating from drawer to full page */
    setExpandTarget(
      conversationId?: string | null,
      participantName?: string | null,
      leftPanel?: 'inbox' | 'directory' | null,
    ) {
      this.expandTarget = {
        conversationId: conversationId ?? null,
        participantName: participantName ?? null,
        leftPanel: leftPanel ?? null,
      }
    },
    /** Consume handoff state on full page mount (returns and clears) */
    consumeExpandTarget() {
      const target = { ...this.expandTarget }
      this.expandTarget = {
        conversationId: null,
        participantName: null,
        leftPanel: null,
      }
      return target
    },
  },
})
